const carousels = document.querySelectorAll('.carousel-component')

if (carousels.length > 0) {
  carousels.forEach((carousel) => {
    const carouselSlides = carousel.querySelectorAll('.carousel-slide')
    const autoplayBtn = carousel.querySelector(
      '.carousel-controls__autoplay-btn'
    )
    const prevSlideBtn = carousel.querySelector('.carousel-controls__prev-btn')
    const nextSlideBtn = carousel.querySelector('.carousel-controls__next-btn')
    const currentSlideOutput = carousel.querySelector(
      '.carousel-controls__current-slide'
    )
    const totalSlides = parseInt(
      carousel.querySelector('.carousel-controls__total-slides').textContent
    )
    const slideAnimateOutClass = 'carousel-slide--animate-out'
    const slideShownClass = 'carousel-slide--shown'
    const autoplayEnabled =
      carousel.dataset.autoplayEnabled === 'True' ? true : false
    const autoplayTiming =
      carousel.dataset.autoplayTiming > 0
        ? carousel.dataset.autoplayTiming * 1000
        : 0

    let currentSlide = 1
    let currentSlidesPosition = [...Array(carouselSlides.length)].map(
      (u, i) => i * -1
    )
    let currentSlideElement = null
    let previousSlideElement = null
    let slideAnimationDuration = 2800
    let carouselSlideAnimating = false
    let carouselPaused = false
    let autoplayTimeout = null

    // set initial slide z-index
    carouselSlides.forEach((slide, i) => {
      slide.style.zIndex = i * -1
    })

    //set 1st carousel slide props
    carouselSlides[0].classList.add(slideShownClass)
    carouselSlides[0].setAttribute('aria-hidden', false)

    function showPreviousSlide() {
      previousSlideElement = carouselSlides[currentSlide - 1]

      // get new carousel slides z-indexes
      currentSlidesPosition = currentSlidesPosition.map((pos) => {
        if (pos === (currentSlidesPosition.length - 1) * -1) {
          return 0
        } else {
          return (pos -= 1)
        }
      })

      previousSlideElement.classList.add(slideAnimateOutClass)

      // set current slides
      if (currentSlide - 1 < 1) {
        currentSlide = totalSlides
      } else {
        currentSlide -= 1
      }

      updateSlides()
    }

    function showNextSlide() {
      previousSlideElement = carouselSlides[currentSlide - 1]

      // get new carousel slides z-indexes
      currentSlidesPosition = currentSlidesPosition.map((pos) => {
        if (pos === 0) {
          return (currentSlidesPosition.length - 1) * -1
        } else {
          return (pos += 1)
        }
      })

      previousSlideElement.classList.add(slideAnimateOutClass)

      // set current slides
      if (currentSlide + 1 > totalSlides) {
        currentSlide = 1
      } else {
        currentSlide += 1
      }

      updateSlides()
    }

    function updateSlides() {
      currentSlideElement = carouselSlides[currentSlide - 1]

      currentSlideOutput.textContent = currentSlide

      carouselSlideAnimating = true

      previousSlideElement.classList.remove(slideShownClass)
      currentSlideElement.classList.add(slideShownClass)

      previousSlideElement.setAttribute('aria-hidden', true)
      currentSlideElement.setAttribute('aria-hidden', false)

      // set new slide z-indexes
      carouselSlides.forEach((slide, i) => {
        slide.style.zIndex = currentSlidesPosition[i]
      })

      if (autoplayEnabled) {
        window.clearTimeout(autoplayTimeout)
      }

      if (autoplayEnabled && carouselPaused) {
        playCarousel()
      }

      setTimeout(() => {
        carouselSlideAnimating = false

        previousSlideElement.classList.remove(slideAnimateOutClass)

        if (autoplayEnabled) {
          autoplayTimeout = window.setTimeout(showNextSlide, autoplayTiming)
        }
      }, slideAnimationDuration)
    }

    function playCarousel() {
      carouselPaused = false
      autoplayBtn.classList.remove('carousel-controls__autoplay-btn--paused')
      autoplayBtn.setAttribute('aria-label', 'Pause Carousel')
      autoplayBtn.setAttribute('aria-pressed', 'false')
    }

    function pauseCarousel() {
      carouselPaused = true
      autoplayBtn.classList.add('carousel-controls__autoplay-btn--paused')
      autoplayBtn.setAttribute('aria-label', 'Resume Carousel')
      autoplayBtn.setAttribute('aria-pressed', 'true')
      window.clearTimeout(autoplayTimeout)
    }

    prevSlideBtn.addEventListener('click', () => {
      if (!carouselSlideAnimating) {
        showPreviousSlide()
      }
    })

    nextSlideBtn.addEventListener('click', () => {
      if (!carouselSlideAnimating) {
        showNextSlide()
      }
    })

    carousel.addEventListener('swiped-right', () => {
      if (!carouselSlideAnimating) {
        showPreviousSlide()
      }
    })

    carousel.addEventListener('swiped-left', () => {
      if (!carouselSlideAnimating) {
        showNextSlide()
      }
    })

    if (autoplayEnabled) {
      // Set autoplay timeout to show next slide
      autoplayTimeout = window.setTimeout(showNextSlide, autoplayTiming)

      autoplayBtn.addEventListener('click', function () {
        if (!carouselSlideAnimating) {
          if (carouselPaused) {
            // Play Carousel
            playCarousel()
            showNextSlide()
          } else {
            // Pause Carousel
            pauseCarousel()
          }
        }
      })
    }
  })
}

let vh = window.innerHeight * 0.01
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`)

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})
